import {
  Box,
  Button,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import React from 'react';
import { createStyles } from './ScheduledPostListWrapper.styles';
import { BACK_TO_FEED, SCHEDULED_POSTS_TITLE } from '../text';
import CloseButton from '@app/components/presentational/common/CloseButton/CloseButton';

interface ScheduledPostListWrapperProps {
  children: React.ReactNode;
  count?: number;
  onClose?: () => void;
}

const ScheduledPostListWrapper = ({
  children,
  count = 0,
  onClose = () => {},
}: ScheduledPostListWrapperProps) => {
  const styles = createStyles(useTheme());
  // Show title with count if count is greater than 0
  const title =
    count > 0 ? `${SCHEDULED_POSTS_TITLE} (${count})` : SCHEDULED_POSTS_TITLE;

  return (
    <Box sx={styles.scheduledPostListContainer}>
      <Box sx={styles.scheduledPostListHeader}>
        <Button
          aria-label={BACK_TO_FEED}
          kind="secondary"
          onClick={onClose}
          startIcon={<Icons.WestOutlined aria-hidden="true" />}
          sx={styles.backButton}
          type="button"
        >
          {BACK_TO_FEED}
        </Button>
        <Box sx={styles.titleRow}>
          <Typography component="h1" variant="h6" sx={styles.title}>
            {title}
          </Typography>
          <CloseButton sx={styles.closeButton} onClick={onClose} />
        </Box>
      </Box>
      <Box sx={styles.scheduledPostListScroll}>
        <Box sx={styles.scheduledPostListContent}>{children}</Box>
      </Box>
    </Box>
  );
};

export default ScheduledPostListWrapper;
